import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ServicesFormFields } from "web_myplann/Portfolio/Forms/ServicesForm/ServicesFormFields";
import { useCreateServicesForm } from "web_myplann/Portfolio/Forms/ServicesForm/useCreateServicesForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateServicesForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateServicesForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddServices.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<ServicesFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
